import React from "react";
import { Checkbox,   Grid } from "@material-ui/core";
import { Mutation } from "react-apollo";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { Link } from 'react-router-dom';
import style from "./style";
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import Fab from "@material-ui/core/Fab/Fab";
import DinerButton from '../../components/DinerButton';
import InputField from "../../components/Field";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";

const SizeSchema = Yup.object().shape({
  size: Yup.number()
    .nullable()
    .max(10000,'Please enter a valid size'),
  price: Yup.number()
    .required()
    .integer('Please enter valid Price')
    .min(50, 'Minimum price $50'),
  hourlyPrice: Yup.number()
    .required('hourly price is a required field')
    .integer('Please enter valid Hourly Price')
    .min(10, 'Minimum price $10'),
});

class Size extends React.Component {
  componentDidMount() {
    window.onload = function() {
      window.scrollTo(0, 0);
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      size: props.maxDiners || 0,
      price: props.minEngagementPrice || "",
      hourlyPrice: props.hourlyPrice || "",
      termsPrivacy: props.chefPrivacyTerms
    };
  }

  handleTermsPrivacy = () => {
    this.setState({ termsPrivacy: !this.state.termsPrivacy });
  };

  render() {
    return (
      <div className="chef-right-col">
        <div className="schedule-head-col">
          <div className="header-step-col">
            <p className="located-text" style={style.headerText}>
              Engagement Details
            </p>
            <div className="cont-btn">
              <DinerButton />
            </div>
          </div>
        </div>

        <div className="schedule-head-col" style={{ marginTop:30 }}>
          <div className="header-step-col">
            <p className="located-text" style={style.headerText2}>
              Maximum diners per engagement
            </p>
          </div>
        </div>

        <p style={style.subHeaderText}>
          How many can you serve in an engagement?
        </p>
        <Mutation mutation={UPDATE_CHEF}>
          {updateChef => (
            <Formik
              initialValues={{
                size: this.state.size == 0 ? null : this.state.size,
                price: this.state.price,
                hourlyPrice: this.state.hourlyPrice
              }}
              enableReinitialize
              validationSchema={SizeSchema}
              onSubmit={this.props.onSubmit(updateChef)}
              isInitialValid={SizeSchema.isValidSync(this.state)}
            >
              {({ errors, touched, isValid, isSubmitting }) => (
                <Form>
                  <Grid container>
                    <div className="schedule-col">
                      <Grid
                        item
                        xs={12}
                        style={{
                          textAlign: "left"
                        }}
                        className="engagement-input-col"
                      >
                        <InputField
                          name={"size"}
                          placeholder={"Enter Size (No Limit)"}
                          error={errors.size && touched.size}
                          errorMessage={errors.size}
                          hideLabel={true}
                          type={"text"}
                          inputType={"number"}
                        />
                      </Grid>
                    </div>
                  </Grid>

                    <div className="schedule-head-col" style={{ marginTop: 30 }}>
                        <div className="header-step-col">
                            <p className="located-text" style={style.headerText2}>
                                Minimum Price
                            </p>
                        </div>
                    </div>
                    <p style={style.subHeaderTextTwo}>
                        What is your minimum engagement price?
                    </p>
                    <Grid container>
                        <Grid
                            item
                            md={6}
                            xs={12}
                            style={{
                                display: "flex"
                            }}
                            className="engagement-input-col"
                        >
                            <InputField
                                name={"price"}
                                placeholder={"Enter Price"}
                                error={errors.price && touched.price}
                                errorMessage={errors.price}
                                hideLabel={true}
                                type={"text"}
                                inputType={"number"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">$</InputAdornment>
                                    )
                                }}
                            />

                        </Grid>

                      <Grid item md={7} xs={12}>
                        <div className="schedule-head-col" style={{ marginTop: 30 }}>
                          <div className="header-step-col">
                            <p className="located-text" style={style.headerText2}>
                              Hourly Price
                            </p>
                          </div>
                        </div>
                        <p style={style.subHeaderTextTwo}>
                          What is your hourly price for custom engagements?
                        </p>
                      </Grid>
                      <Grid container>
                        <Grid
                          item
                          md={6}
                          xs={12}
                          style={{
                            display: "flex"
                          }}
                          className="engagement-input-col"
                        >
                          <InputField
                            name="hourlyPrice"
                            placeholder={"Enter Hourly Price"}
                            error={errors.hourlyPrice && touched.hourlyPrice}
                            errorMessage={errors.hourlyPrice}
                            hideLabel={true}
                            type={"text"}
                            inputType={"number"}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">$</InputAdornment>
                              )
                            }}
                          />

                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{
                          display: "flex",
                          marginTop: 40,
                          fontFamily: "Poppins",
                        }}
                      >
                        <div style={{ marginLeft: -9 }}>
                          <Checkbox
                            data-test-id={"signup-tnc"}
                            onChange={this.handleTermsPrivacy}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                            value={this.state.termsPrivacy}
                            checked={this.state.termsPrivacy}
                          />
                        </div>
                        <div style={{ marginTop: -9 }}>
                          <p style={{ display: 'block', fontSize: 16 }}>
                            I understand that Cuisine Crafters expects any Chef on the platform to have the needed business license and liability insurance as noted earlier in the <Link target="_blank" style={{color: '#ff8000'}} to={"/terms-of-use"}>Terms of Use</Link>.
                          </p>
                        </div>
                      </Grid>
                        <Grid item md={12} sm={12} style={{ textAlign: "right" }}>
                            <div style={style.fieldContainer}>
                                <Fab
                                    id={"price-submit"}
                                    data-test-id={"pricesubmit"}
                                    variant={"extended"}
                                    type="submit"
                                    style={isValid && this.state.termsPrivacy ? style.submitButton : style.disabledSubmitButton}
                                    disabled={!this.state.termsPrivacy || !isValid || isSubmitting}
                                >
                                    Continue
                                </Fab>
                            </div>
                        </Grid>
                    </Grid>

                </Form>
              )}
            </Formik>
          )}
        </Mutation>
      </div>
    );
  }
}

export default Size;
